import { useSyncExternalStore } from 'react'

import type { RouteHistory } from './types'

/**
 * The live-followed route of each Route History card, by insight configuration id.
 *
 * The map and the card's footer are separate components that each receive only the loaded
 * data, so the points, door openings and alerts the map picks up while following live are
 * published here for the footer's counts to follow too.
 */
const routes = new Map<string, RouteHistory>()
const listeners = new Set<() => void>()

const notify = () => {
  for (const listener of listeners) listener()
}

export const publishLiveRoute = (id: string, route: RouteHistory | undefined) => {
  if (route) {
    routes.set(id, route)
  } else {
    routes.delete(id)
  }
  notify()
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** The card's live route if the map is following one, else `fallback` (the loaded data). */
export const useLiveRoute = <T extends RouteHistory | undefined>(id: string, fallback: T): RouteHistory | T =>
  useSyncExternalStore(subscribe, () => routes.get(id)) ?? fallback
